<template>
  <div class="login-wrap">
    <div class="login-overlay"></div>
    <div class="login-content">
      <el-form label-position="left" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="0px" class="login-container tech-glass">
        <div class="logo-box">
          <img src="../assets/img/logo.png" alt="" class="login-logo">
          <h2 class="title">笑眯眯后台管理系统</h2>
        </div>
        <el-form-item prop="username">
          <el-input type="text" v-model="ruleForm.username" auto-complete="off" placeholder="请输入账号">
            <i slot="prefix" class="el-icon-user"></i>
          </el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input type="password" v-model="ruleForm.password" auto-complete="off" placeholder="请输入密码" @keyup.enter.native="submitForm('ruleForm')">
            <i slot="prefix" class="el-icon-lock"></i>
          </el-input>
        </el-form-item>
        <div class="remember-row">
          <el-checkbox v-model="rememberPassword">记住密码</el-checkbox>
        </div>
        <el-form-item style="width:100%; margin-top: 30px;">
          <el-button type="primary" class="login-btn" @click="submitForm('ruleForm')" :loading="logining">立即登录</el-button>
        </el-form-item>
        <div class="login-footer">
          <span>© 2026 笑眯眯. All Rights Reserved.</span>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import { login } from '../api/userMG'
import { setCookie, getCookie, delCookie } from '../utils/util'

export default {
  name: 'login',
  data() {
    return {
      logining: false,
      rememberPassword: false,
      ruleForm: {
        username: '',
        password: ''
      },
      rules: {
        username: [{ required: true, message: '请输入账号', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      }
    }
  },
  created() {
    this.getuserpwd()
  },
  methods: {
    getuserpwd() {
      if (getCookie('user') != '' && getCookie('pwd') != '') {
        this.ruleForm.username = getCookie('user')
        this.ruleForm.password = getCookie('pwd')
        this.rememberPassword = true
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.logining = true
          login(this.ruleForm).then(res => {
            if (res.code == 200) {
              if (this.rememberPassword) {
                setCookie('user', this.ruleForm.username, 7)
                setCookie('pwd', this.ruleForm.password, 7)
              } else {
                delCookie('user')
                delCookie('pwd')
              }
              
              this.$message.success('登录成功，正在跳转...')
              setTimeout(() => {
                localStorage.setItem('logintoken', res.data.token)
                localStorage.setItem('userdata', JSON.stringify(res.data.info))
                this.$store.commit('login', 'true')
                this.$router.push({ path: '/User/SchoolMap' })
                this.logining = false
              }, 800)
            } else {
              this.$message.error(res.msg || '登录失败')
              this.logining = false
            }
          }).catch(() => {
            this.$message.error('网络错误，请稍后再试')
            this.logining = false
          })
        }
      })
    }
  }
}
</script>

<style scoped>
.login-wrap {
  position: relative;
  width: 100%;
  height: 100vh;
  background: url(../assets/img/bg.png) no-repeat center center;
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.login-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(0, 122, 255, 0.1) 0%, rgba(0, 0, 0, 0.4) 100%);
  z-index: 1;
}

.login-content {
  position: relative;
  z-index: 2;
  width: 100%;
  max-width: 420px;
  padding: 20px;
}

.login-container {
  border-radius: 20px;
  padding: 40px;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.logo-box {
  text-align: center;
  margin-bottom: 40px;
}

.login-logo {
  height: 60px;
  margin-bottom: 15px;
}

.title {
  font-size: 24px;
  font-weight: 700;
  color: #fff;
  letter-spacing: 2px;
  margin: 0;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.el-input /deep/ .el-input__inner {
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.3);
  color: #fff !important;
  height: 48px;
  border-radius: 12px;
}

.el-input /deep/ .el-input__inner::placeholder {
  color: rgba(255, 255, 255, 0.6);
}

.el-input /deep/ .el-input__prefix {
  left: 12px;
  color: rgba(255, 255, 255, 0.7);
  font-size: 18px;
  line-height: 48px;
}

.login-btn {
  height: 50px;
  font-size: 18px;
  letter-spacing: 4px;
  border-radius: 12px;
  background: linear-gradient(90deg, #007aff 0%, #00c6ff 100%);
  border: none;
  box-shadow: 0 10px 20px rgba(0, 122, 255, 0.3);
  transition: all 0.3s;
}

.login-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 15px 25px rgba(0, 122, 255, 0.4);
}

.remember-row {
  display: flex;
  justify-content: flex-end;
  margin-top: -6px;
}

.remember-row /deep/ .el-checkbox__label {
  color: rgba(255, 255, 255, 0.85);
}

.remember-row /deep/ .el-checkbox__inner {
  background: rgba(255, 255, 255, 0.12);
  border-color: rgba(255, 255, 255, 0.45);
}

.remember-row /deep/ .el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #007aff;
  border-color: #007aff;
}

.login-footer {
  text-align: center;
  margin-top: 30px;
  color: rgba(255, 255, 255, 0.5);
  font-size: 12px;
}

.tech-glass {
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(20px);
}
</style>



// WEBPACK FOOTER //
// src/views/login.vue